exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-127c8038],th[data-v-127c8038]{padding-left:1px;text-align:left}ol[data-v-127c8038],ul[data-v-127c8038]{padding-left:14px;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-127c8038","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/school/lessonPlan/lessonPlanPrint.vue
// module id = 125
// module chunks = 0